import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { RoleEnum } from '@affiliation/enums';
import { SellersApi, TeamApi, SupervisorApi } from '~/api';
import { encryptText } from '~/plugins/crypto';
export var state = function state() {
	return {
		teams: [{
			items: []
		}],
		responseSeller: '',
		dataTeam: '',
		idChannel: null
	};
};

export var actions = {
	loadDateTeam: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, data) {
			var dispatch = _ref.dispatch;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return dispatch('list', data);

						case 2:
							_context.next = 4;
							return dispatch('nameTeam', data);

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function loadDateTeam(_x, _x2) {
			return _ref2.apply(this, arguments);
		}

		return loadDateTeam;
	}(),
	list: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, data) {
			var rootState = _ref3.rootState,
			    commit = _ref3.commit;
			var conditional, team;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							conditional = rootState.user.roleId === RoleEnum.SUPERVISOR ? rootState.user.idTeam : data.id;
							_context2.next = 3;
							return new SellersApi(this.$axios).getSellersManagement({
								idTeam: conditional || 0,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 3:
							team = _context2.sent;

							console.warn('TEAMS FROM STORE', team);
							commit('setList', team);
							return _context2.abrupt('return', team);

						case 7:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function list(_x3, _x4) {
			return _ref4.apply(this, arguments);
		}

		return list;
	}(),
	nameTeam: function () {
		var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, data) {
			var rootState = _ref5.rootState,
			    commit = _ref5.commit;
			var conditional, nameTeam;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							conditional = rootState.user.roleId === RoleEnum.SUPERVISOR ? rootState.user.idTeam : data.id;
							_context3.next = 3;
							return new TeamApi(this.$axios).findTeamForEdit({
								idTeam: conditional || 0
							});

						case 3:
							nameTeam = _context3.sent;

							commit('dataTeamSelect', nameTeam);
							return _context3.abrupt('return', nameTeam);

						case 6:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function nameTeam(_x5, _x6) {
			return _ref6.apply(this, arguments);
		}

		return nameTeam;
	}(),
	createdNewTeam: function () {
		var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7, data) {
			var state = _ref7.state,
			    rootState = _ref7.rootState;
			var conditional;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							conditional = rootState.user.roleId === RoleEnum.BOSS ? data.id : state.idChannel;
							_context4.next = 3;
							return new TeamApi(this.$axios).createdNewTeam({
								idChannel: conditional,
								name: data.name,
								temporaryRegistration: data.temporaryRegistration,
								multicomercioRegistration: data.multicomercioRegistration,
								isActive: data.isActive
							});

						case 3:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function createdNewTeam(_x7, _x8) {
			return _ref8.apply(this, arguments);
		}

		return createdNewTeam;
	}(),
	editTeam: function () {
		var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9, data) {
			var state = _ref9.state,
			    rootState = _ref9.rootState,
			    dispatch = _ref9.dispatch,
			    commit = _ref9.commit;
			var response, conditional;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return dispatch('findTeamForEdit', data.idTeam);

						case 2:
							response = _context5.sent;
							conditional = rootState.user.roleId === RoleEnum.BOSS ? data.idChannel : response.IdChannel;
							_context5.next = 6;
							return new TeamApi(this.$axios).editTeam({
								idTeam: data.idTeam,
								idChannel: conditional,
								name: data.name,
								temporaryRegistration: data.temporaryRegistration,
								multicomercioRegistration: data.multicomercioRegistration,
								isActive: data.isActive,
								idSupervisor: response.IdSupervisor || 0
							});

						case 6:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function editTeam(_x9, _x10) {
			return _ref10.apply(this, arguments);
		}

		return editTeam;
	}(),
	findTeamForEdit: function () {
		var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11, data) {
			var state = _ref11.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return new TeamApi(this.$axios).findTeamForEdit({
								idTeam: data
							});

						case 2:
							response = _context6.sent;
							return _context6.abrupt('return', response);

						case 4:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, this);
		}));

		function findTeamForEdit(_x11, _x12) {
			return _ref12.apply(this, arguments);
		}

		return findTeamForEdit;
	}(),
	findSellerById: function () {
		var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13, data) {
			var state = _ref13.state,
			    commit = _ref13.commit;
			var response;
			return _regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return new SellersApi(this.$axios).findSellerById({
								idSeller: data
							});

						case 2:
							response = _context7.sent;

							commit('responseOfSeller', response);
							return _context7.abrupt('return', response);

						case 5:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, this);
		}));

		function findSellerById(_x13, _x14) {
			return _ref14.apply(this, arguments);
		}

		return findSellerById;
	}(),
	editSeller: function () {
		var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15, data) {
			var state = _ref15.state;
			return _regeneratorRuntime.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return new SellersApi(this.$axios).editSeller(_extends({
								idUser: state.responseSeller.idUser,
								idRole: data.idRole,
								idDocumentType: data.idDocumentType,
								firstName: data.firstName,
								lastName: data.lastName,
								documentNumber: data.documentNumber,
								email: data.email,
								username: state.responseSeller.username,
								password: state.responseSeller.password,
								isActive: data.active
							}, data));

						case 2:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function editSeller(_x15, _x16) {
			return _ref16.apply(this, arguments);
		}

		return editSeller;
	}(),
	createdNewSeller: function () {
		var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17, data) {
			var state = _ref17.state;
			return _regeneratorRuntime.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							data.idChannel = state.idChannel;
							// await new SellersApi(this.$axios).createdNewSeller(data)
							_context9.next = 3;
							return new SellersApi(this.$axios).createdNewSeller({
								idTeam: data.idTeam,
								idRole: data.idRole,
								idDocumentType: data.idDocumentType,
								firstName: data.firstName,
								lastName: data.lastName,
								documentNumber: data.documentNumber,
								email: data.email,
								username: '',
								password: '',
								isSupervisor: data.isSupervisor,
								isActive: data.isActive,
								cellphone: data.cellphone,
								channelCode: data.channelCode,
								channelName: data.channelName,
								subChannelCode: data.subChannelCode,
								subChannelName: data.subChannelName,
								groupChannelCode: data.groupChannelCode,
								groupChannelName: data.groupChannelName,
								idUserCategory: data.idUserCategory
							});

						case 3:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, this);
		}));

		function createdNewSeller(_x17, _x18) {
			return _ref18.apply(this, arguments);
		}

		return createdNewSeller;
	}(),
	editTeamManagement: function () {
		var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19, data) {
			var state = _ref19.state;
			return _regeneratorRuntime.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							_context10.next = 2;
							return new TeamApi(this.$axios).editTeamManagement({
								idTeam: data.idTeam,
								active: data.isActive
							});

						case 2:
						case 'end':
							return _context10.stop();
					}
				}
			}, _callee10, this);
		}));

		function editTeamManagement(_x19, _x20) {
			return _ref20.apply(this, arguments);
		}

		return editTeamManagement;
	}(),
	editSellerManagement: function () {
		var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21, data) {
			var state = _ref21.state;
			return _regeneratorRuntime.wrap(function _callee11$(_context11) {
				while (1) {
					switch (_context11.prev = _context11.next) {
						case 0:
							_context11.next = 2;
							return new SellersApi(this.$axios).editSellerManagement({
								idSeller: data.idSeller,
								active: data.isActive
							});

						case 2:
						case 'end':
							return _context11.stop();
					}
				}
			}, _callee11, this);
		}));

		function editSellerManagement(_x21, _x22) {
			return _ref22.apply(this, arguments);
		}

		return editSellerManagement;
	}(),
	teamValidNewTeam: function () {
		var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23, data) {
			var state = _ref23.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee12$(_context12) {
				while (1) {
					switch (_context12.prev = _context12.next) {
						case 0:
							_context12.next = 2;
							return new TeamApi(this.$axios).teamValidNewTeam({
								idChannel: data.idChannel,
								name: data.name
							});

						case 2:
							response = _context12.sent;
							return _context12.abrupt('return', response);

						case 4:
						case 'end':
							return _context12.stop();
					}
				}
			}, _callee12, this);
		}));

		function teamValidNewTeam(_x23, _x24) {
			return _ref24.apply(this, arguments);
		}

		return teamValidNewTeam;
	}(),
	validEditTeam: function () {
		var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref25, data) {
			var state = _ref25.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee13$(_context13) {
				while (1) {
					switch (_context13.prev = _context13.next) {
						case 0:
							_context13.next = 2;
							return new TeamApi(this.$axios).validEditTeam({
								idChannel: data.idChannel,
								idTeam: data.idTeam,
								name: data.name
							});

						case 2:
							response = _context13.sent;
							return _context13.abrupt('return', response);

						case 4:
						case 'end':
							return _context13.stop();
					}
				}
			}, _callee13, this);
		}));

		function validEditTeam(_x25, _x26) {
			return _ref26.apply(this, arguments);
		}

		return validEditTeam;
	}(),
	validSellersEmail: function () {
		var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref27, data) {
			var state = _ref27.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee14$(_context14) {
				while (1) {
					switch (_context14.prev = _context14.next) {
						case 0:
							_context14.next = 2;
							return new SellersApi(this.$axios).validSellersEmail({
								idUser: data.idUser,
								email: data.email
							});

						case 2:
							response = _context14.sent;
							return _context14.abrupt('return', response);

						case 4:
						case 'end':
							return _context14.stop();
					}
				}
			}, _callee14, this);
		}));

		function validSellersEmail(_x27, _x28) {
			return _ref28.apply(this, arguments);
		}

		return validSellersEmail;
	}(),
	validationDocumentNumberSeller: function () {
		var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref29, data) {
			var state = _ref29.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee15$(_context15) {
				while (1) {
					switch (_context15.prev = _context15.next) {
						case 0:
							_context15.next = 2;
							return new SellersApi(this.$axios).validationDocumentNumberSeller({
								idUser: data.idUser,
								documentNumber: data.documentNumber
							});

						case 2:
							response = _context15.sent;
							return _context15.abrupt('return', response);

						case 4:
						case 'end':
							return _context15.stop();
					}
				}
			}, _callee15, this);
		}));

		function validationDocumentNumberSeller(_x29, _x30) {
			return _ref30.apply(this, arguments);
		}

		return validationDocumentNumberSeller;
	}(),
	editSupervisor: function () {
		var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref31, data) {
			var state = _ref31.state;
			return _regeneratorRuntime.wrap(function _callee16$(_context16) {
				while (1) {
					switch (_context16.prev = _context16.next) {
						case 0:
							_context16.next = 2;
							return new SupervisorApi(this.$axios).editSupervisor(_extends({
								idUser: state.responseSeller.idUser,
								idRole: data.idRole,
								idDocumentType: data.idDocumentType,
								firstName: data.firstName,
								lastName: data.lastName,
								documentNumber: data.documentNumber,
								email: data.email,
								username: state.responseSeller.username,
								password: state.responseSeller.password,
								isActive: data.active
							}, data));

						case 2:
						case 'end':
							return _context16.stop();
					}
				}
			}, _callee16, this);
		}));

		function editSupervisor(_x31, _x32) {
			return _ref32.apply(this, arguments);
		}

		return editSupervisor;
	}(),
	validationPasswordSupervisor: function () {
		var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref33, data) {
			var dispatch = _ref33.dispatch,
			    state = _ref33.state,
			    rootState = _ref33.rootState;
			var cancellationToken;
			return _regeneratorRuntime.wrap(function _callee17$(_context17) {
				while (1) {
					switch (_context17.prev = _context17.next) {
						case 0:
							_context17.next = 2;
							return dispatch('getCancellationToken', null, { root: true });

						case 2:
							cancellationToken = _context17.sent;
							_context17.next = 5;
							return new SupervisorApi(this.$axios).validationPasswordSupervisor({
								idUser: rootState.user.userId,
								password: encryptText(data.password)
							}, cancellationToken);

						case 5:
						case 'end':
							return _context17.stop();
					}
				}
			}, _callee17, this);
		}));

		function validationPasswordSupervisor(_x33, _x34) {
			return _ref34.apply(this, arguments);
		}

		return validationPasswordSupervisor;
	}(),
	validationPasswordSellers: function () {
		var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref35, data) {
			var dispatch = _ref35.dispatch,
			    rootState = _ref35.rootState;
			var cancellationToken;
			return _regeneratorRuntime.wrap(function _callee18$(_context18) {
				while (1) {
					switch (_context18.prev = _context18.next) {
						case 0:
							_context18.next = 2;
							return dispatch('getCancellationToken', null, { root: true });

						case 2:
							cancellationToken = _context18.sent;
							_context18.next = 5;
							return new SellersApi(this.$axios).validationPasswordSellers({
								idUser: rootState.user.userId,
								password: encryptText(data.password)
							}, cancellationToken);

						case 5:
						case 'end':
							return _context18.stop();
					}
				}
			}, _callee18, this);
		}));

		function validationPasswordSellers(_x35, _x36) {
			return _ref36.apply(this, arguments);
		}

		return validationPasswordSellers;
	}()
};

export var mutations = {
	setList: function setList(state, teams) {
		for (var i = 0; i < state.teams.length; i++) {
			state.teams[i].items = teams.map(function (item) {
				var conditional = item.Role === 'Supervisor' ? true : false;
				return {
					firstName: item.Firstname,
					lastName: item.Lastname,
					name: item.Firstname + ' ' + item.Lastname,
					boss: item.Boss,
					active: item.IsActive === 0 ? false : true,
					role: item.Role,
					value: item.IdUser,
					supervisor: conditional,
					user: item.Username,
					phone: item.Cellphone,
					documentType: item.DocumentType,
					documentNumber: item.DocumentNumber,
					team: item.Team,
					email: item.Email,
					channel: item.ChannelName,
					subchannel: item.SubChannelName,
					groupChannelName: item.GroupChannelName
				};
			});
		}
	},
	responseOfSeller: function responseOfSeller(state, data) {
		state.responseSeller = data;
	},
	dataTeamSelect: function dataTeamSelect(state, data) {
		state.dataTeam = data;
	},
	setIdChannel: function setIdChannel(state, data) {
		state.idChannel = data;
	},
	updateStatusSeller: function updateStatusSeller(state, data) {
		for (var i = 0; i < state.teams[0].items.length; i++) {
			// encontrar el canal
			if (state.teams[0].items[i].value === data.val.value) {
				state.teams[0].items[i].active = data.val.status;
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/team.js
// module id = ./src/store/team.js
// module chunks = 34